import type { StepConfig } from '../../types/workflow';

const maxValues = {
  seconds: 86400,
  minutes: 1440,
  hours: 24,
};

const automationConnector: StepConfig = {
  icon: 'automationConnector',
  headerTextColor: '#5E35B1',
  headerColor: '#EDE7F6',
  title: 'Ai Agent Connector',
  text: 'Trigger external automation',
  category: 'Router',
  desc: 'Connect to an external Ai agents and services through an Agent ID Connector.',
  primaryKey: 'flowId',
  connectors: {
    AutomationSuccess: {
      headerTextColor: '#4CAF50',
      headerColor: '#E8F5E9',
      title: 'Success',
      category: 'Connector',
    },
    AutomationFailure: {
      headerTextColor: '#F44336',
      headerColor: '#FFEBEE',
      title: 'Failure',
      category: 'Connector',
    },
    Timeout: {
      headerTextColor: '#5E35B1',
      headerColor: '#EDE7F6',
      title: 'Failure:Timeout',
      category: 'Connector',
      show: (nodeData: Record<string, any>) => {
        return nodeData.timeout?.hasTimeout === true;
      },
    },
  },
  formFields: [
    {
      key: 'flowId',
      type: 'text',
      label: 'Flow ID',
      placeholder: 'Enter Flow ID',
      defaultValue: '',
      validation: {
        required: true,
      },
    },
    {
      key: 'timeout.hasTimeout',
      label: 'Advanced Settings',
      type: 'accordion',
      defaultValue: false,
      fields: [
        {
          key: 'timeout.unit',
          label: 'Unit',
          type: 'select',
          defaultValue: 'minutes',
          options: [
            { label: 'Seconds', value: 'seconds' },
            { label: 'Minutes', value: 'minutes' },
            { label: 'Hours', value: 'hours' },
          ],
          dependsOn: ['timeout.hasTimeout'],
          onChange: (value, allValues, allFields) => {
            if (value === 'seconds') {
              if (allFields['timeout.value'] && allFields['timeout.value'].validation) {
                allFields['timeout.value'].validation.maxValue = maxValues.seconds;
              }
            } else if (value === 'minutes') {
              if (allFields['timeout.value'] && allFields['timeout.value'].validation) {
                allFields['timeout.value'].validation.maxValue = maxValues.minutes;
              }
            } else {
              if (allFields['timeout.value'] && allFields['timeout.value'].validation) {
                allFields['timeout.value'].validation.maxValue = maxValues.hours;
              }
            }
          },
        },
        {
          key: 'timeout.value',
          label: 'Timeout',
          type: 'number',
          defaultValue: 1,
          dependsOn: ['timeout.hasTimeout', 'timeout.unit'],
          validation: {
            required: true,
            numeric: true,
            integer: true,
            minValue: 1,
            maxValue: maxValues.minutes,
          },
        },
      ],
    },
  ],
};

export default automationConnector;
